import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Theme,
    Typography
} from "@mui/material";
import {formatDate, formatPeso, getMinMaxDate} from "../../helpers";
import Strings from "../../assets/strings";
import {Close, FilterList} from "@mui/icons-material";
import React, {useCallback, useEffect, useState} from "react";
import {delCajaCierre, getCajasCierres} from "../../services";
import {mostrarCajaById} from "../../redux/reducers/cajasReducers";
import {ButtonResponsive, ConfirmDialog, ListViewMode, Pagination} from "../../components";
import {ICajaCierre, ICajaCierreFilter, ICajaCierreRes} from "../../redux/types/ICaja";
import makeStyles from "@mui/styles/makeStyles";
import CajaMovimientos from "./CajaMovimientos";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import {useLocation, useNavigate} from "react-router-dom";

const useStyles = makeStyles((theme:Theme) => ({
    content: {
        padding: "0 !important",
    },
    tHead:{
        background:"rgb(237, 247, 237)"
    }
}));

const initialFilter:ICajaCierreFilter = {fechaDesde:"",fechaHasta:""} //,cmoTipo:"",cciId:""
export default function CajaCierres({cajId, defaultCierres}:{cajId:number, defaultCierres?:ICajaCierreRes}){
    const classes = useStyles();
    const navigate = useNavigate();
    let {state:urlState, pathname} = useLocation();

    const [cieFiltered,setCieFiltered] = useState<ICajaCierre[]>();

    const [loading,setLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false)
    const [filter, setFilter] = useState(initialFilter);

    const [list, setList] = useState<ICajaCierreRes>()

    const [cierreDetalle, setCierreDetalle] = useState<ICajaCierre>()


    useEffect(() => {
        setList(defaultCierres)
    }, [setList, defaultCierres]);



    const filterCie = useCallback((obj:any)  => {
        setLoading(true);
        setOpenFilter(false);

        getCajasCierres(cajId,obj).then(res=>{
            // setActiveTab(1);
            setList(res.data)
        }).finally(()=>setLoading(false))
    },[setLoading, setOpenFilter, setList, cajId])
    const eliminarCierre = ({cajaId, cierreId}:{cajaId: number, cierreId:number}) =>{
        if(cajaId && cierreId){
            delCajaCierre(cajaId, cierreId).then(()=> mostrarCajaById(cajaId))
        }
    }

    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name, value} = e.target;

        setFilter({...filter,[name]:value});

        if(name === "name" || name === "page" || name === "pageSize") return  filterCie({...filter,page:1,[name]:value});
    };
    let resetFilter = ()=>{
        setFilter(initialFilter);
        filterCie(filter)
    }

    return <>
        {!!cieFiltered &&
            <Alert icon={false} onClose={() => setCieFiltered(undefined)}>
                <>Cierres: {getMinMaxDate(cieFiltered)}</>
            </Alert>
        }


        <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} maxWidth={"xs"} >
            <TopBarDialog title={Strings.filtrar} onClose={()=>setOpenFilter(false)} light/>

            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <TextField
                            label={Strings.fechaDesde}
                            type="date"
                            value={filter.fechaDesde}
                            fullWidth
                            InputLabelProps={{shrink: true}}
                            onChange={({target})=>setFilter({...filter,fechaDesde:target.value})}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={Strings.fechaHasta}
                            type="date"
                            value={filter.fechaHasta}
                            fullWidth
                            InputLabelProps={{shrink: true}}
                            onChange={({target})=>setFilter({...filter, fechaHasta:target.value})}
                        />
                    </Grid>
                    {/*{activeTab === 0 &&*/}
                    {/*<Grid item xs={12}>*/}
                    {/*    <SelectEnum value={filter.cmoTipo}*/}
                    {/*                group={"tiposCajasMovimiento"}*/}
                    {/*                label={Strings.tipo}*/}
                    {/*                all*/}
                    {/*                onChange={({target}:any)=>setFilter({...filter, cmoTipo:target.value})}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                    {/*}*/}

                </Grid>
                <br/>
            </DialogContent>
            <DialogActions>
                <Button onClick={resetFilter} color={"warning"} size={"small"} sx={{textTransform:"capitalize"}}>
                    {Strings.restablecer}
                </Button>
                <Button color="primary" onClick={()=>filterCie(filter)} variant={"outlined"}>
                    {Strings.filtrar}
                </Button>
            </DialogActions>
        </Dialog>


        <ListViewMode pageRows={list?.pageSize} pageTotalRows={list?.totalCount}>
            <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(true)}/>

        </ListViewMode>
        <TableContainer>
            <Table sx={{minWidth: 743}} size={"small"} className="hasOnclick">
                <TableHead className={!!cieFiltered ? classes.tHead : ""}>
                    <TableRow>
                        <TableCell/>
                        <TableCell>{Strings.fecha}</TableCell>
                        <TableCell>{Strings.monto}</TableCell>
                        <TableCell className="comment">{Strings.comentario}</TableCell>
                        <TableCell>{Strings.creadoPor}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {list?.items?.map((row, i) => {
                            return (
                                <TableRow key={row.id} className={row.fechaAnulacion ? "text-red-deep" : ""}
                                          onClick={()=>setCierreDetalle(row)}
                                          // onClick={() => filterMov && filterMov(row.id!)}
                                >

                                    <TableCell className={"actionCell"} onClick={e=>e.stopPropagation()} sx={{width:34}}>
                                        {row?.anulable &&
                                            <IconButton
                                                onClick={(e)=>{
                                                    navigate(pathname,{state:{confirmDialog: {delCierre: {cajaId: row.cajaId!, cierreId: row.id!}}}})
                                                }}
                                                size="large">
                                                <Close className={"text-red"}/>
                                            </IconButton>
                                        }
                                    </TableCell>

                                    <TableCell>{formatDate(row.fechaCreacion)} {formatDate(row.fechaCreacion, "hh:mm a")}</TableCell>
                                    <TableCell>{formatPeso(row.monto)}</TableCell>
                                    <TableCell className="comment" >{row.nota}</TableCell>
                                    <TableCell colSpan={!row.fechaAnulacion ? 2 : 1}>{row.usuarioCreadoPor}</TableCell>

                                </TableRow>
                            );
                    })}
                </TableBody>
            </Table>
        </TableContainer>

        {list &&
            <Pagination
                empty={Boolean(!list.items?.length && loading)}
                count={list.totalCount || 0}
                rowsPerPage={filter.pageSize??15}
                page={list.pageNumber - 1}
                onPageChange={(e, page) => {
                    filterCie({...filter,page:page + 1})
                }}
                onRowsPerPageChange={handleFilter}
            />
        }

        <Dialog open={!!cierreDetalle?.id} onClose={()=>setCierreDetalle(undefined)} maxWidth={"lg"} >
            <TopBarDialog title={Strings.cierre} onClose={()=>setCierreDetalle(undefined)}/>
            <Box sx={{background:"#f9f9f9", p:1}}>
                <Table size={"small"} className={"noHover"}>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <Typography variant={"body2"} fontWeight={500}>{Strings.fecha}</Typography>
                                {formatDate(cierreDetalle?.fechaCreacion)}
                            </TableCell>
                            <TableCell >
                                <Typography variant={"body2"} fontWeight={500}>{Strings.creadoPor}</Typography>
                                {cierreDetalle?.usuarioCreadoPor}
                            </TableCell>
                            <TableCell align={"right"}>
                                <Typography variant={"body2"} fontWeight={500}>{Strings.monto}</Typography>
                                {formatPeso(cierreDetalle?.monto)}
                            </TableCell>
                        </TableRow>
                        {!!cierreDetalle?.nota &&
                            <TableRow>
                                <TableCell colSpan={3} sx={{border:"none"}}>
                                    <b>Nota:</b> {cierreDetalle?.nota}
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </Box>
            <DialogContent>
                <Typography color={"primary"} mb={1}>{Strings.movimientos}:</Typography>
                {cajId &&
                    <CajaMovimientos defaultMovimientos={undefined} cajId={cajId} cierreId={cierreDetalle?.id}/>
                }
            </DialogContent>
        </Dialog>

        {urlState?.confirmDialog?.delCierre &&
            <ConfirmDialog onConfirm={()=>{
                eliminarCierre(urlState?.confirmDialog.delCierre)
            }}/>
        }
    </>
}
